import * as api from './types/api.js';
import * as global from './types/global.js';
import * as google from './types/google.js';
import * as pages from './types/pages.js';

export default {
  ...api,
  ...global,
  ...google,
  ...pages,
};
